import React from 'react';
import Hero from '../../../components/commons/hero/hero.component';
import heroImageSrc from '../../../images/about/policiesHero.svg';
import EducationProgramContent from '../../../components/about/widgets/education-program/education-program.component';
import EducationProgramForm from '../../../components/about/forms/education-program/education-program-form.component';

function EducationProgram({ page: { modules } }) {
  return (
    <div className="education-program-container">
      <Hero
        src={heroImageSrc}
        alt={modules.hero.hero_alt}
        title={modules.hero.hero_title}
        description={modules.hero.hero_description}
        template="standard"
        colorCategory="policies"
      />
      <div className="trinity-container">
        <EducationProgramContent />
        <EducationProgramForm />
      </div>
    </div>
  );
}

export default EducationProgram;
